'use strict';

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    beachBoysInit();
});

function beachBoysInit() {
    var prevTopScroll = 0,
        $beachboysAnimation1 = $('.js-beachboys-animation-1'),
        beachboysAnimation1Offset = 0,
        $beachboysAnimation2 = $('.js-beachboys-animation-2'),
        beachboysAnimation2Offset = 0,
        $beachboysAnimation2Content = $('.js-beachboys-animation-2-content'),
        $beachboysAnimation3 = $('.js-beachboys-animation-3'),
        beachboysAnimation3Offset = 0;

    window.addEventListener('scroll', function () {
        var currentTopScroll = window.pageYOffset,
            currentScroll = currentTopScroll / window.innerHeight;

        // offsets calculation is in scroll event listener to be accurate on any viewport changes to run animation
        if ($beachboysAnimation1.length) {
            beachboysAnimation1Offset = $beachboysAnimation1.offset().top / window.innerHeight;
            document.body.style.setProperty('--scrolloffset1', beachboysAnimation1Offset);
        }

        if ($beachboysAnimation2.length) {
            beachboysAnimation2Offset = $beachboysAnimation2.offset().top / window.innerHeight;
            document.body.style.setProperty('--scrolloffset2', beachboysAnimation2Offset);
        }

        if ($beachboysAnimation3.length) {
            beachboysAnimation3Offset = $beachboysAnimation3.offset().top / window.innerHeight;
            document.body.style.setProperty('--scrolloffset3', beachboysAnimation3Offset);
        }

        document.body.style.setProperty('--scroll1', currentScroll);
        document.body.style.setProperty('--scroll2', currentScroll);
        document.body.style.setProperty('--scroll3', currentScroll);

        // scroll down
        if (currentTopScroll > prevTopScroll) {
            // activate fixed position on animation 2
            if (currentScroll >= beachboysAnimation2Offset) {
                $beachboysAnimation2Content.addClass('animate');
            }

            // activate bottom position on animation 2 - next phase ( + 2 viewports)
            if (currentScroll >= beachboysAnimation2Offset + 2) {
                $beachboysAnimation2Content.addClass('expand');
            }

            // activate bottom position on animation 2 - stop phase ( + 3 viewports)
            if (currentScroll >= beachboysAnimation2Offset + 3) {
                $beachboysAnimation2Content.addClass('bottom').removeClass('animate');
            }
        } else {
        // scroll up
            // activate fixed position on animation 2 ( + 3 viewports)
            if (currentScroll < beachboysAnimation2Offset + 3) {
                $beachboysAnimation2Content.addClass('animate').removeClass('bottom');
            }

            // activate bottom position on animation 2 - next phase ( + 2 viewports)
            if (currentScroll < beachboysAnimation2Offset + 2) {
                $beachboysAnimation2Content.removeClass('expand');
            }

            // deactivate fixed position on animation 2
            if (currentScroll < beachboysAnimation2Offset) {
                $beachboysAnimation2Content.removeClass('animate');
            }
        }

        // update prevTopScroll
        prevTopScroll = currentTopScroll;
    }, false);
}

